/* eslint-disable */
// @ts-nocheck

// This script is direct copy from `includes/builder/scripts/utils/utils.js`, aimed as an example
// of initial version of how script that is used by module is handled in D5. Further step:
// TODO feat(Refactor) Remove eslint-disable and ts-nocheck
// TODO feat(Refactor) properly convert into typescript

// IMPORTANT: Keep external dependencies as low as possible since this utils might be
// imported by various frontend scripts; need to keep frontend script size low.

// External dependencies
import get from 'lodash/get';
import $ from 'jquery';

// Internal dependencies
import { top_window } from '../frame-helpers';

/**
 * Get Builder utils parameters.
 *
 * Get the `et_builder_utils_params` object for either the current window or top window (whichever is found first).
 *
 * @since ??
 *
 * @returns {object} Builder utils parameters.
 */
export const getBuilderUtilsParams = () => {
  if (window.et_builder_utils_params) {
    return window.et_builder_utils_params;
  }

  if (top_window.et_builder_utils_params) {
    return top_window.et_builder_utils_params;
  }

  return {};
};

/**
 * Get the Builder environment type.
 *
 * Get the Builder Type value within `et_builder_utils_params`. Possible values are:
 * - fe: Frontend
 * - vb: Visual Builder
 * - bfb: New Builder Experience
 * - tb: Theme Builder
 * - lbb: Layout Block Builder
 * - lbp: Layout Block Preview
 * - '' (empty string): Unknown
 *
 * @since ??
 *
 * @returns {object} Builder utils parameter `builderType`.
 */
export const getBuilderType = () => get(getBuilderUtilsParams(), 'builderType', '');

/**
 * Check Builder type for the current page.
 *
 * Check if current page's builder type is the same as the one passed in the argument.
 *
 * @since 4.6.0
 *
 * @param {string} builderType Fe|vb|bfb|tb|lbb|lbp.
 *
 * @returns {bool} True if current page's builder type is the same as the one passed in the argument.
 */
export const isBuilderType = builderType => builderType === getBuilderType();

/**
 * Return condition value.
 *
 * Check if current page has a given condition set to true.
 * Condition value is set in `et_builder_utils_params` object.
 * Possible values are:
 * - diviTheme: Divi Theme
 * - extraTheme: Extra Theme
 *
 * @since 4.6.0
 *
 * @param {string} conditionName Condition name.
 *
 * @returns {bool} True if current page's condition value is the same as the one passed in the argument.
 */
export const is = conditionName => get(getBuilderUtilsParams(), `condition.${conditionName}`);

/**
 * Is current page Frontend.
 *
 * Check if current page is rendered in frontend.
 *
 * @since 4.6.0
 *
 * @returns {bool} True if current page is rendered in frontend.
 */
export const isFE = isBuilderType('fe');

/**
 * Is current page Visual Builder.
 *
 * Check if current page is rendered in Visual Builder.
 *
 * @since 4.6.0
 *
 * @returns {bool} True if current page is rendered in Visual Builder.
 */
export const isVB = isBuilderType('vb');

/**
 * Is current page BFB / New Builder Experience.
 *
 * Check if current page is rendered in BFB / New Builder Experience.
 *
 * @since 4.6.0
 *
 * @returns {bool} True if current page is rendered in BFB / New Builder Experience.
 */
export const isBFB = isBuilderType('bfb');

/**
 * Is current page Theme Builder.
 *
 * Check if current page is rendered in Theme Builder.
 *
 * @since 4.6.0
 *
 * @returns {bool} True if current page is rendered in Theme Builder.
 */
export const isTB = isBuilderType('tb');

/**
 * Is current page Layout Block Builder.
 *
 * Check if current page is rendered in Layout Block Builder.
 *
 * @since ??
 *
 * @returns {bool} True if current page is rendered in Layout Block Builder.
 */
export const isLBB = isBuilderType('lbb');

/**
 * Is current page uses Divi Theme.
 *
 * Check if current page uses Divi Theme.
 *
 * @since 4.6.0
 *
 * @returns {bool} True if current page uses Divi Theme.
 */
export const isDiviTheme = is('diviTheme');

/**
 * Is current page uses Extra Theme.
 *
 * Check if current page uses Extra Theme.
 *
 * @since 4.6.0
 *
 * @returns {bool} True if current page uses Extra Theme.
 */
export const isExtraTheme = is('extraTheme');

/**
 * Is current page Layout Block Preview.
 *
 * Check if current page is rendered in Layout Block Preview.
 *
 * @since 4.6.0
 *
 * @returns {bool} True if current page is rendered in Layout Block Preview.
 */
export const isLBP = isBuilderType('lbp');

/**
 * Is current page Block Editor.
 *
 * Check if current window is a block editor window (gutenberg editing page).
 *
 * @since 4.6.0
 *
 * @returns {bool} True if current window is a block editor window (gutenberg editing page).
 */
export const isBlockEditor = 0 < $(top_window.document).find('.edit-post-layout__content').length;

/**
 * Is current page a Builder window.
 *
 * Check if current window is a builder window (VB, BFB, TB, LBB).
 *
 * @since 4.6.0
 *
 * @returns {bool} True if current window is a builder window (VB, BFB, TB, LBB).
 */
export const isBuilder = ['vb', 'bfb', 'tb', 'lbb'].includes(getBuilderType());

/**
 * Check if current window has ET_Builder global object.
 *
 * Check if current window has the ET_Builder global object available, which indicates
 * the builder environment is active.
 *
 * @since ??
 *
 * @returns {bool} True if ET_Builder global object exists and is an object.
 */
export const isInBuilder = () => 'ET_Builder' in window && 'object' === typeof window['ET_Builder' as keyof Window];

/**
 * Get offsets value of all sides.
 *
 * Get offsets value of all sides (top, right, bottom, left) of a given element.
 *
 * @since 4.6.0
 *
 * @param {object} $selector JQuery selector instance.
 * @param {number} height Height of the element.
 * @param {number} width Width of the element.
 *
 * @returns {object} Object containing offsets value of all sides (top, right, bottom, left).
 */
export const getOffsets = ($selector, width = 0, height = 0) => {
  // Return previously saved offset if sticky tab is active; retrieving actual offset contain risk
  // of incorrect offsets if sticky horizontal / vertical offset of relative position is modified.
  const isStickyTabActive = isBuilder && $selector.hasClass('et_pb_sticky') && 'fixed' !== $selector.css('position');
  const cachedOffsets = $selector.data('et-offsets');
  const cachedDevice = $selector.data('et-offsets-device');
  const currentDevice = get(window.ET_FE, 'stores.window.breakpoint', '');

  // Only return cachedOffsets if sticky tab is active and cachedOffsets is not undefined and
  // cachedDevice equal to currentDevice.
  if (isStickyTabActive && typeof cachedOffsets !== 'undefined' && cachedDevice === currentDevice) {
    return cachedOffsets;
  }

  // Get top & left offsets
  const offsets = $selector.offset();
  const hasFixedPositionAncestor =
    0 < $selector.parents().filter((_index, element) => 'fixed' === $(element).css('position')).length;

  // If no offsets found, return empty object
  if ('undefined' === typeof offsets) {
    return {};
  }

  // FE sets the flag for sticky module which uses transform as classname on module wrapper while
  // VB, BFB, TB, and LB sets the flag on CSS output's style element because it can't modify
  // its parent. This compromises avoids the needs to extract transform rendering logic
  const hasTransform = isBuilder
    ? $selector.children('.et-fb-custom-css-output[data-sticky-has-transform="on"]').length > 0
    : $selector.hasClass('et_pb_sticky--has-transform');

  let top = 'undefined' === typeof offsets.top ? 0 : offsets.top;
  let left = 'undefined' === typeof offsets.left ? 0 : offsets.left;

  // If module is sticky module that uses transform, its offset calculation needs to be adjusted
  // because transform tends to modify the positioning of the module
  if (hasTransform) {
    // Calculate offset (relative to selector's parent) AFTER it is affected by transform
    // NOTE: Can't use jQuery's position() because it considers margin-left `auto` which causes issue
    // on row thus this manually calculate the difference between element and its parent's offset
    // @see https://github.com/jquery/jquery/blob/1.12-stable/src/offset.js#L149-L155
    const parentOffsets = $selector.parent().offset();

    const transformedPosition = {
      top: offsets.top - parentOffsets.top,
      left: offsets.left - parentOffsets.left,
    };

    // Calculate offset (relative to selector's parent) BEFORE it is affected by transform
    const preTransformedPosition = {
      top: $selector[0].offsetTop,
      left: $selector[0].offsetLeft,
    };

    // Update offset's top value
    top += preTransformedPosition.top - transformedPosition.top;
    offsets.top = top;

    // Update offset's left value
    left += preTransformedPosition.left - transformedPosition.left;
    offsets.left = left;
  }

  // Fixed-position ancestors keep the selector's viewport position stable, while jQuery's offset
  // includes the current window scroll position.
  if (hasFixedPositionAncestor) {
    top -= window.scrollY;
    offsets.top = top;
  }

  // Manually calculate right & bottom offsets
  offsets.right = left + width;
  offsets.bottom = top + height;

  // Save copy of the offset on element's .data() in case of scenario where retrieving actual
  // offset value will lead to incorrect offset value (eg. sticky tab active with position offset)
  $selector.data('et-offsets', offsets);

  // Add current device to cache
  if ('' !== currentDevice) {
    $selector.data('et-offsets-device', offsets);
  }

  return offsets;
};

/**
 * Maybe increase max listeners.
 *
 * Increase EventEmitter's max listeners if lister count is about to surpass the max listeners limit
 * IMPORTANT: This needs to be placed BEFORE `.on()`.
 *
 * @since 4.6.0
 *
 * @param {EventEmitter} emitter EventEmitter instance.
 * @param {string} eventName Event name.
 *
 * @returns {void}
 */
export const maybeIncreaseEmitterMaxListeners = (emitter, eventName) => {
  const currentCount = emitter.listenerCount(eventName);
  const maxListeners = emitter.getMaxListeners();

  if (currentCount === maxListeners) {
    emitter.setMaxListeners(maxListeners + 1);
  }
};

/**
 * Maybe decrease max listeners.
 *
 * Decrease EventEmitter's max listeners if listener count is less than max listener limit and above
 * 10 (default max listener limit). If listener count is less than 10, max listener limit will
 * remain at 10
 * IMPORTANT: This needs to be placed AFTER `.removeListener()`.
 *
 * @since 4.6.0
 *
 * @param {EventEmitter} emitter EventEmitter instance.
 * @param {string} eventName Event name.
 *
 * @returns {void}
 */
export const maybeDecreaseEmitterMaxListeners = (emitter, eventName) => {
  const currentCount = emitter.listenerCount(eventName);
  const maxListeners = emitter.getMaxListeners();

  if (maxListeners > 10) {
    emitter.setMaxListeners(currentCount);
  }
};

/**
 * Register the Frontend component.
 *
 * Expose frontend (FE) component via global object so it can be accessed and reused externally
 * Note: `window.ET_Builder` is for builder app's component; `window.ET_FE` is for frontend component.
 *
 * @since 4.6.0
 *
 * @param {string} type Module type.
 * @param {string} name Module name.
 * @param {mixed} component Module component.
 *
 * @returns {void}
 */
export const registerFrontendComponent = (type, name, component) => {
  // Make sure that ET_FE is available
  if ('undefined' === typeof window.ET_FE) {
    window.ET_FE = {};
  }

  if ('object' !== typeof window.ET_FE[type]) {
    window.ET_FE[type] = {};
  }

  window.ET_FE[type][name] = component;
};

/**
 * Set inline style with an `!important` tag.
 *
 * JQuery's .css() can't set value with an `!important` tag, so here it is.
 *
 * @since 4.6.2
 *
 * @param {object} $element JQuery selector instance.
 * @param {string} cssProp CSS property.
 * @param {string} value CSS property value.
 *
 * @returns {void}
 */
export const setImportantInlineValue = ($element, cssProp, value) => {
  // Remove prop from current inline style in case the prop is already exist
  $element.css(cssProp, '');

  // Get current inline style
  const inlineStyle = $element.attr('style');

  // Re-insert inline style + property with important tag
  $element.attr('style', `${inlineStyle} ${cssProp}: ${value} !important;`);
};
